/* istanbul ignore file */
import React from 'react';
import { ClientContext } from '@thd-nucleus/app-render/dist/client';
import B2BTheme, { ExchangeTheme } from '@thd-olt-global/b2b-theme';
import { NewRelicBridge } from '@thd-olt-component-react/new-relic-bridge';
import { ThdAnalytics } from '@thd-olt-component-react/thd-analytics';
import { App } from './App';
import { getRoutes } from './routes.js';

ThdAnalytics.init();
NewRelicBridge.init();

document.addEventListener('DOMContentLoaded', async () => {
  const client = new ClientContext();
  client.setExperienceRoutes(getRoutes());

  if (client.serverData.themeName === 'exchange') {
    client.setTheme({ name: 'exchange', template: ExchangeTheme });
  } else if (client.customer.type === 'b2b') {
    client.setTheme({ name: 'b2b', template: B2BTheme });
  }

  const customerType =
    client.customer.type || window.THDCustomer?.default.customerType || '';
  const customerRole =
    client.customer.role || window.THDCustomer?.default.role || '';

  client.render(
    <App
      customerType={customerType}
      customerRole={customerRole}
      prefetchPip={client.featureSwitches.prefetchPip}
      productPodHoverDelay={client.featureSwitches.productPodHoverDelay}
    />,
  );
});
